export enum CP_URLS {
  BASE = 'performance-per-company',
  ASSETS = 'assets',
  KPIs = 'kpis',
  PREDICTION = 'prediction',
  VALUATION = 'valuation',
  DOCUMENTS = 'documents',
  TEAM = 'team',
}
